import {svgIconWrapper} from '../svg-icon-wrapper';

import UserDigestRegularAi from './user-digest-regular-ai-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <UserDigestRegularAi {...props} />;
}

SvgComponent.iconName = 'userDigestRegularAi';

export const UserDigestRegularAiIcon = svgIconWrapper(SvgComponent);
